import { render, staticRenderFns } from "./usage.vue?vue&type=template&id=338f054a&scoped=true&"
var script = {}
import style0 from "./usage.vue?vue&type=style&index=0&id=338f054a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f054a",
  null
  
)

export default component.exports